// Translator notes: the users' decisions on Peterson's rules of 2026-10-06 (docs/TRANSLATOR-PHASE4.md
// "Decisions for the users"): clause-final "before" = gō (engine rules/temporal-clauses.ts), "encourage"
// and "pass" (rules/verb-senses.ts), generic statements in the aorist (rules/generic-aorist.ts).
// Each id is an engine note (`notes.add(text, id, args)`); `args` names its arguments in the order the
// strings take them. Collected by translator/notes.ts (import.meta.glob): adding a note means adding it here.
import { defineNotes } from '../note-defs';

export const notes = defineNotes({
  beforeAdverbGo: {
    args: ['hv', 'also'],
    fi: (a: string[]) =>
      `”Before” ilman jatkoa on ajan adverbi ${a[0]}, kuten Petersonin lauseessa ”daorys gō istas” (kukaan ei ole mennyt aiemmin). Vaihtoehdoissa on ${a[1]} ’aiemmin’ (oppitunti 41).`,
    en: (a: string[]) =>
      `“Before” with nothing after it is the time adverb ${a[0]}, as in Peterson’s “daorys gō istas” (no one has gone before). The alternatives have ${a[1]} “previously” (lesson 41).`,
  },
  encourageKustikagon: {
    args: [],
    fi: () =>
      '”Encourage” on kustikagon, ja sen objekti on akkusatiivissa, kuten Petersonin lauseessa ”Ābre kustittas lua vala raqiros issa” (mies, joka rohkaisi naista, on ystävä). Vaihtoehdoissa on nēdākogon, jonka objekti on lokatiivissa.',
    en: () =>
      '“Encourage” is kustikagon with the object in the accusative, as in Peterson’s “Ābre kustittas lua vala raqiros issa” (the man who encouraged the woman is a friend). The alternatives have nēdākogon, whose object is in the locative.',
  },
  passRebagon: {
    args: [],
    fi: () =>
      'Ihminen tai eläin kulkee ohi: rēbagon, kuten Petersonin lauseessa ”Ynot rēbagon” (päästä minut ohi). Aika ja asiat menevät ohi verbillä jagon (”Kesir sepār īlza” = tämäkin menee ohi).',
    en: () =>
      'A person or an animal passing: rēbagon, as in Peterson’s “Ynot rēbagon” (let me pass). Time and things pass with jagon (“Kesir sepār īlza” = this too shall pass).',
  },
  genericAorist: {
    args: [],
    fi: () =>
      'Yleinen toteamus: verbi on aoristissa ja objekti kollektiivissa, kuten Peterson suosittaa (”Kēliri jorrāelin” = rakastan kissoja; oppitunti 38). Preesens on vaihtoehdoissa.',
    en: () =>
      'A general statement: the verb is in the aorist and the object in the collective, as Peterson prefers (“Kēliri jorrāelin” = I love cats; lesson 38). The present is in the alternatives.',
  },
});

declare module '../note-defs' {
  interface NoteIds extends Record<keyof typeof notes, true> {}
}
